import { useQuery, useMutation } from "@tanstack/react-query";

export const sessionReportKeys = {
  all: ["botSessionReports"],
  items: () => [...sessionReportKeys.all, "item"],
  item: ({ botId, memberId, createdAt }) => [
    ...sessionReportKeys.items(),
    botId,
    memberId,
    createdAt,
  ],
};

// Queries

export function useBotSessionReport(func, args, queryOptions = {}) {
  return useQuery({
    queryKey: sessionReportKeys.item(args),
    queryFn: () => func(args),
    ...queryOptions,
  });
}

// Mutations

export function useCreateBotSessionReport(func, mutationOptions = {}) {
  return useMutation({
    mutationFn: ({ botId, body }) => func(botId, body),
    ...mutationOptions,
  });
}
